import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AdsPreview } from '../../types';
import ImgProfilePost from '../../components/Post/ImgProfilePost';
import ImgVerified from '../../components/imgVerified/ImgVerified';
import ImgPost from '../../components/Post/ImgPost/ImgPost';
import OptionsPost from '../../components/Post/OptionsPost';
import { ContainerButtonAds } from '../../components/container-button-ads/container-button-ads';
import { ChevronDown } from 'lucide-react';
import { censorText, clearText } from '../../global-components/src/utils/text';

interface PostProps {
    ads: AdsPreview;
    numbers: number | null;
}

const PreviewAds: React.FC<PostProps> = ({ ads, numbers = 100 }) => {
    const [processedText, setProcessedText] = useState<string>(ads?.text?.trim() ? clearText(censorText(ads?.text)) : "");
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [canExpand, setCanExpand] = useState<boolean>(false);
    const textRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        setProcessedText(ads?.text ? clearText(censorText(ads?.text)) : "");
    }, [ads?.text]);

    useEffect(() => {
        if (textRef.current) {
            const realHeight = textRef.current.scrollHeight;
            const onlyEmoji = processedText.trim().match(/^<img[^>]*class=['"]emoji['"][^>]*>$/);
            setCanExpand(realHeight > 300 && !onlyEmoji);
        }
    }, [ads?.text]);

    // Build a stable mock Post so we can reuse real Post sub-components.
    // Deps are primitives only so the object identity only changes when real data changes,
    // preventing OptionsPost from re-initialising its internal useState on every parent render.
    const mockPost: any = useMemo(() => ({
        id: 0,
        id_user: ads?.user?.id ?? 0,
        user: ads?.user ?? { name: "Você", img_account: null },
        group_id: null,
        group: null,
        original_post: null,
        poll: null,
        images: ads.images ?? [],
        text: ads.text ?? "",
        gif_url: null,
        created_at: "",
        liked: false,
        is_saved: false,
        has_is_following: false,
        is_following: false,
        total_likes: 0,
        total_comments: 0,
        total_shares: 0,
        total_saved: 0,
        ads: {
            id: 0,
            id_post: 0,
            name: "",
            status: "ativo",
            post: null,
            button_text: ads.buttonText,
            button_url: ads.buttonUrl,
            price: ads.price,
        },
    }), [
        ads?.user?.id,
        ads?.user?.name,
        ads?.user?.img_account,
        ads.text,
        ads.buttonText,
        ads.buttonUrl,
        ads.price,
        // images length as a cheap proxy — a new upload changes the count
        ads.images?.length,
    ]);

    return (
        <div>
            <div className="card card-post-preview card-post">
                <div className="row row-post" style={{ flexWrap: "nowrap" }}>
                    <div className="row row-inside-post">
                        <ImgProfilePost post={mockPost} />

                        <div className="col col-post col-post-not-community" style={{ cursor: "default" }}>
                            <h2 className="cursor-pointer">
                                <span className="link-name">{ads.user?.name ?? "Você"}</span>
                                <ImgVerified user={ads?.user} classNameProp="user-select-none img-verificado-comentario" />
                            </h2>
                            <p className='text-date-post'>anúncio</p>

                            <div className="col-1 col-conf-post">
                                <div className="dropdown">
                                    <button aria-label="Configuração do POST" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button">
                                        <ChevronDown color='var(--color-text-post)' size={20} opacity={.6} />
                                    </button>
                                </div>
                            </div>

                            {processedText && (
                                <div
                                    style={{ maxHeight: !isExpanded ? "200px" : "none", overflow: "hidden" }}
                                    className={`row row-text-post ${canExpand ? "cursor-pointer" : ""}`}
                                    onClick={() => canExpand && setIsExpanded(!isExpanded)}
                                >
                                    <p
                                        ref={textRef}
                                        className="text-post post text-expand"
                                        dangerouslySetInnerHTML={{ __html: processedText }}
                                    />
                                    {!isExpanded && canExpand && (
                                        <span className="point-post"><span>Ler mais</span></span>
                                    )}
                                </div>
                            )}

                            {ads?.images && ads.images.length > 0 && (
                                <ImgPost mock={true} images={ads.images} />
                            )}

                            <ContainerButtonAds post={mockPost} />
                            <OptionsPost
                                post={mockPost}
                                onRepost={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewAds;
